export default function initAccordions() {
	const accordionHeaders = document.querySelectorAll('.accordion-header')

	if (!accordionHeaders) {
		return
	}

	accordionHeaders.forEach(header => {
		const isActive = header.classList.contains('active')

		const accordionContent = header.nextElementSibling
		accordionContent.style.maxHeight = isActive ? accordionContent.scrollHeight + 'px' : 0

		header.addEventListener('click', () => {
			const isOpening = !header.classList.contains('active')

			accordionHeaders.forEach(otherHeader => {
				otherHeader.classList.remove('active')
				otherHeader.nextElementSibling.style.maxHeight = 0
			})

			if (isOpening) {
				header.classList.add('active')
				header.nextElementSibling.style.maxHeight = header.nextElementSibling.scrollHeight + 'px'
			}
		})
	})
}
